(function () {
  function normalise(value) {
    return (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function setupDirectory(root) {
    var search = root.querySelector('[data-armade-maker-search]');
    var sort = root.querySelector('[data-armade-maker-sort]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-armade-letter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-armade-maker-card]'));
    var grid = root.querySelector('[data-armade-maker-grid]');
    var status = root.querySelector('[data-armade-maker-status]');
    var noResults = root.querySelector('[data-armade-no-results]');
    var viewport = root.querySelector('[data-armade-az-viewport]');
    var previous = root.querySelector('[data-armade-az-previous]');
    var next = root.querySelector('[data-armade-az-next]');
    var activeLetter = 'all';

    if (!search || !cards.length) return;

    cards.forEach(function (card, index) {
      if (!card.getAttribute('data-maker-order')) {
        card.setAttribute('data-maker-order', String(index + 1));
      }
      if (!card.getAttribute('data-maker-count')) {
        var countText = card.querySelector('.armade-directory-card__count');
        var parsedCount = parseInt(countText ? countText.textContent : '0', 10);
        card.setAttribute('data-maker-count', String(isNaN(parsedCount) ? 0 : parsedCount));
      }
    });

    function compareByName(left, right) {
      return normalise(left.getAttribute('data-maker-name')).localeCompare(
        normalise(right.getAttribute('data-maker-name'))
      );
    }

    function sortCards() {
      if (!grid) return;
      var mode = sort ? sort.value : 'featured';
      var sorted = cards.slice().sort(function (left, right) {
        if (mode === 'az') return compareByName(left, right);
        if (mode === 'za') return compareByName(right, left);
        if (mode === 'count-desc') {
          var countDifference = Number(right.getAttribute('data-maker-count')) - Number(left.getAttribute('data-maker-count'));
          return countDifference || compareByName(left, right);
        }
        return Number(left.getAttribute('data-maker-order')) - Number(right.getAttribute('data-maker-order'));
      });
      sorted.forEach(function (card) { grid.appendChild(card); });
    }

    function updateCarouselButtons() {
      if (!viewport) return;
      var maximum = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      if (previous) previous.disabled = viewport.scrollLeft <= 2;
      if (next) next.disabled = viewport.scrollLeft >= maximum - 2;
    }

    function keepLetterVisible(button) {
      if (!button || !viewport) return;
      button.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    function update() {
      var query = normalise(search.value);
      var shown = 0;

      cards.forEach(function (card) {
        var title = normalise(card.getAttribute('data-maker-name'));
        var letter = normalise(card.getAttribute('data-maker-letter'));
        var matchesQuery = !query || title.indexOf(query) !== -1;
        var matchesLetter = activeLetter === 'all' || letter === activeLetter;
        var visible = matchesQuery && matchesLetter;
        card.hidden = !visible;
        if (visible) shown += 1;
      });

      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.getAttribute('data-armade-letter') === activeLetter));
      });

      if (status) {
        status.textContent = shown + (shown === 1 ? ' maker shown' : ' makers shown');
      }
      if (noResults) {
        noResults.hidden = shown !== 0;
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeLetter = button.getAttribute('data-armade-letter');
        update();
        keepLetterVisible(button);
      });
    });

    if (sort) {
      sort.addEventListener('change', function () {
        sortCards();
        update();
      });
    }

    if (previous && viewport) {
      previous.addEventListener('click', function () {
        viewport.scrollBy({ left: -Math.max(220, viewport.clientWidth * 0.8), behavior: 'smooth' });
      });
    }

    if (next && viewport) {
      next.addEventListener('click', function () {
        viewport.scrollBy({ left: Math.max(220, viewport.clientWidth * 0.8), behavior: 'smooth' });
      });
    }

    if (viewport) {
      viewport.addEventListener('scroll', updateCarouselButtons, { passive: true });
      viewport.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        var enabledButtons = buttons.filter(function (button) { return !button.disabled; });
        var currentIndex = enabledButtons.indexOf(document.activeElement);
        if (currentIndex === -1) currentIndex = enabledButtons.findIndex(function (button) {
          return button.getAttribute('data-armade-letter') === activeLetter;
        });
        var step = event.key === 'ArrowRight' ? 1 : -1;
        var target = enabledButtons[Math.max(0, Math.min(enabledButtons.length - 1, currentIndex + step))];
        if (target) {
          event.preventDefault();
          target.focus();
          keepLetterVisible(target);
        }
      });
    }

    window.addEventListener('resize', updateCarouselButtons);

    search.addEventListener('input', update);
    search.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        search.value = '';
        activeLetter = 'all';
        update();
        keepLetterVisible(buttons[0]);
      }
    });

    sortCards();
    update();
    window.requestAnimationFrame(updateCarouselButtons);
  }

  function init(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('[data-armade-maker-directory]')).forEach(setupDirectory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

(function () {
  function atMidday(year, month, day) {
    return new Date(year, month - 1, day, 12, 0, 0, 0);
  }

  function nthWeekday(year, month, weekday, occurrence) {
    var first = atMidday(year, month, 1);
    var offset = (weekday - first.getDay() + 7) % 7;
    return atMidday(year, month, 1 + offset + ((occurrence - 1) * 7));
  }

  function easterSunday(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = ((19 * a) + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + (2 * e) + (2 * i) - h - k) % 7;
    var m = Math.floor((a + (11 * h) + (22 * l)) / 451);
    var month = Math.floor((h + l - (7 * m) + 114) / 31);
    var day = ((h + l - (7 * m) + 114) % 31) + 1;
    return atMidday(year, month, day);
  }

  function eventDateForYear(card, year) {
    var rule = card.getAttribute('data-event-rule') || 'fixed';
    if (rule === 'easter') return easterSunday(year);
    var month = Number(card.getAttribute('data-event-month'));
    if (rule === 'nth_weekday') {
      return nthWeekday(
        year,
        month,
        Number(card.getAttribute('data-event-weekday')),
        Number(card.getAttribute('data-event-occurrence'))
      );
    }
    return atMidday(year, month, Number(card.getAttribute('data-event-day')));
  }

  function nextEventDate(card, today) {
    var date = eventDateForYear(card, today.getFullYear());
    var todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    if (date < todayStart) date = eventDateForYear(card, today.getFullYear() + 1);
    return date;
  }

  function setupOccasionDirectory(root) {
    var upcomingGrid = root.querySelector('[data-armade-upcoming-grid]');
    var laterGrid = root.querySelector('[data-armade-later-seasonal-grid]');
    var moreGrid = root.querySelector('[data-armade-more-occasion-grid]');
    var empty = root.querySelector('[data-armade-seasonal-empty]');
    var limit = Number(root.getAttribute('data-featured-limit')) || 4;
    var today = new Date();
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-armade-seasonal-card]'));

    if (!upcomingGrid || !laterGrid || !moreGrid || !cards.length) return;

    cards.forEach(function (card) {
      var date = nextEventDate(card, today);
      card._armadeEventDate = date;
      var label = card.querySelector('[data-armade-seasonal-date]');
      if (label) {
        label.textContent = new Intl.DateTimeFormat('en-US', {
          month: 'short',
          day: 'numeric',
          year: date.getFullYear() === today.getFullYear() ? undefined : 'numeric'
        }).format(date);
      }
    });

    cards.sort(function (left, right) {
      var dateDifference = left._armadeEventDate - right._armadeEventDate;
      if (dateDifference) return dateDifference;
      return Number(left.getAttribute('data-event-order')) - Number(right.getAttribute('data-event-order'));
    });

    cards.forEach(function (card, index) {
      (index < limit ? upcomingGrid : laterGrid).appendChild(card);
    });

    if (empty) empty.hidden = upcomingGrid.children.length > 0;
  }

  function initOccasions(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll('[data-armade-occasion-directory]')).forEach(setupOccasionDirectory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initOccasions(document); });
  } else {
    initOccasions(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initOccasions(event.target); });
})();
